/* eslint-disable react/jsx-fragments */
import React from 'react';
import { Label } from './styles';

export default function Version({
  value = '0.0.0',
  dark = false,
}) {
  return (
    <React.Fragment>
      <Label dark={dark}>{value}</Label>
    </React.Fragment>
  );
}
